<template>
  <span v-if="!disabled">
    <dl class="row-dl mb-0 mt-4">
      <dt class="col-sm-12 text-left mb-2 pr-0 pl-0">
        <div class="bg-light pt-2 pb-2 pl-3">Supported Features</div>
      </dt>
      <template v-for="(f, p) in drivers_supported_features">
        <dt class="col-sm-9">
          <em style="font-size: small;font-weight: 400;">{{ Object.keys(f)[0] }}</em>
        </dt>
        <dd class="col-sm-3">
          <div class="pull-right">
            <i
              v-if="drivers_supported_features[p][Object.keys(f)[0]][feature]"
              class="p-1 bg-success fa fa-check fa-xs"
            ></i>
            <i v-else class="p-1 bg-danger fa fa-times-rectangle fa-xs"></i>
          </div>
        </dd>
      </template>
    </dl>
    <p class="mt-2 mb-0">
      <a :href="documentation_officials[feature]" target="_blank">
        <em>
          <i class="mr-1 fa fa-link"></i>
          Official guide
        </em>
      </a>
    </p>
  </span>
</template>
<script>
export default {
	data() {
		return {
			documentation_officials: {
				facebook: 'https://developers.facebook.com/docs/messenger-platform/getting-started/quick-start',
				telegram: 'https://core.telegram.org/bots#3-how-do-i-create-a-bot',
				hangouts: 'https://developers.google.com/hangouts/chat/how-tos/bots-publish?authuser=1',
			},
			drivers_supported_features: [
				{
					'Question-Buttons': {
						facebook: true,
						telegram: true,
						hangouts: true,
					},
				},
				{
					'Image Attachment': {
						facebook: true,
						telegram: true,
						hangouts: true,
					},
				},
				{
					'Video Attachment': {
						facebook: true,
						telegram: true,
						hangouts: !true,
					},
				},
				{
					'Audio Attachment': {
						facebook: true,
						telegram: true,
						hangouts: !true,
					},
				},
				{
					'Location Attachment': {
						facebook: true,
						telegram: true,
						hangouts: !true,
					},
				},
			],
		}
	},
	props: {
		feature: {
			required: true,
			type: String,
		},
		disabled: {
			type: Boolean,
			default: () => false,
		},
	},
	name: 'supported-feature',
}
</script>
